import { Link } from 'react-router-dom';
import { Heart } from '@phosphor-icons/react';

export function Footer() {
  return (
    <footer className="bg-white border-t border-border mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          {/* Logo & Copyright */}
          <div className="flex flex-col items-center sm:items-start gap-1">
            <div className="flex items-center gap-2 text-muted-foreground">
              <Heart weight="fill" className="w-5 h-5 text-primary" />
              <span className="text-sm">
                © {new Date().getFullYear()} MEDICULDIGITAL – Platforma Medicală S8NTH
              </span>
            </div>
            <span className="text-xs text-muted-foreground/70">
              Powered by S8NTH Strategic Engine
            </span>
          </div>

          {/* Legal Links */}
          <nav className="flex items-center gap-6 text-sm">
            <Link 
              to="/terms" 
              target="_blank"
              className="text-muted-foreground hover:text-primary transition-colors"
              data-testid="footer-terms-link"
            >
              Termeni și Condiții
            </Link>
            <Link 
              to="/gdpr" 
              target="_blank"
              className="text-muted-foreground hover:text-primary transition-colors"
              data-testid="footer-gdpr-link"
            >
              GDPR
            </Link>
            <Link 
              to="/security-policy" 
              target="_blank"
              className="text-muted-foreground hover:text-primary transition-colors"
              data-testid="footer-security-link"
            >
              Politica de Securitate
            </Link>
            <Link 
              to="/contact" 
              className="text-muted-foreground hover:text-primary transition-colors"
              data-testid="footer-contact-link"
            >
              Contact
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
